var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.createEdit)?_c('v-btn',{staticClass:"mr-2",attrs:{"icon":"","color":"grey darken-3"},on:{"click":_vm.edit}},[_c('v-icon',[_vm._v(" fa fa-edit ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }